import PropTypes from 'prop-types';
import React from 'react';

import EndAndClose from './end_and_close';
import SendButton from 'components/customer/composition/send_button';

export default function ChatActions({ isEditorEmpty, onSubmit }) {
  if (isEditorEmpty) {
    return <EndAndClose isEditorEmpty />;
  }

  return <SendButton onClick={onSubmit}>Send</SendButton>;
}

ChatActions.propTypes = {
  isEditorEmpty: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/chat/chat_actions.jsx